import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Backup from '@material-ui/icons/Backup';
import CustomButton from 'components/CustomInput/Button';

const useStyles = makeStyles((theme) => ({
    input: {
        display: 'none',
    },
}));

export default function UploadButtons({ iconOnly = false }) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <input accept="image/*" className={classes.input} id="contained-button-file" multiple type="file" />
            <label htmlFor="contained-button-file">
                {iconOnly ? (
                    <Backup style={{ color: '#3f51b5', cursor: 'pointer' }} />
                ) : (
                    <CustomButton component="span">Upload</CustomButton>
                )}
            </label>
        </div>
    );
}
